export enum AddressMethod {
  ClientNamesOnly,
  ClientCompanyAndClientName,
  ClientNamesAndPlannerName,
  ClientNamesAndPlannerCompany,
  PlannerNameOnly,
  PlannerCompanyOnly,
  PlannerCompanyAndPlannerName
}

export const addressMethodOptions = [
  { id: AddressMethod.ClientNamesOnly, label: 'Client Name(s) Only' },
  { id: AddressMethod.ClientCompanyAndClientName, label: 'Client Company c/o Client Name' },
  { id: AddressMethod.ClientNamesAndPlannerName, label: 'Client Name(s) c/o Planner Name' },
  { id: AddressMethod.ClientNamesAndPlannerCompany, label: 'Client Name(s) c/o Planner Company' },
  { id: AddressMethod.PlannerNameOnly, label: 'Planner Name Only' },
  { id: AddressMethod.PlannerCompanyOnly, label: 'Planner Company Only' },
  { id: AddressMethod.PlannerCompanyAndPlannerName, label: 'Planner Company c/o Planner Name' }
];
